import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  physicians: [],
  total_pages: 1,
  search: [],
  searchValue: "",
  chats: [],
  chat: undefined,
  page: 0,
  sharedFiles: [],
  selectedPhysician: 0,
  users: [],
  after_call_chat: [],
  is_chat_notification: false,
};

const ongoingAppointment = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PHYSICIANS:
      return {
        ...state,
        physicians: [...action.payload.results],
        total_pages: action.payload.total_pages,
      };
    case actionTypes.SET_ONGOINGAPPOINTMENT_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.SET_SHARED_FILES:
      return {
        ...state,
        sharedFiles: [...state.sharedFiles, action.payload],
      };

    case actionTypes.REMOVE_SHARED_DOCUMENTS: {
      const chats = [...state.chats];

      const sharedFiles = [...state.sharedFiles];

      const updatedChats = chats.filter(
        chat => chat?.data?.toLowerCase() !== action.payload?.toLowerCase()
      );

      const updatedSharedFiles = sharedFiles.filter(
        sharedFile => sharedFile !== action.payload
      );

      return {
        ...state,
        chats: updatedChats,
        sharedFiles: updatedSharedFiles,
      };
    }
    case actionTypes.REMOVE_ONGOINGAPPOINTMENT_DATA:
      return {
        ...initialState,
        vitals: state?.vitals,
        currentAppointment: state.currentAppointment,
      };

    case actionTypes.REMOVE_PARTICIPANTS:
      return {
        ...state,
        physicians: [],
        total_pages: 1,
        search: [],
        searchValue: "",
        selectedSpeciality: null,
      };

    case actionTypes.SET_CHAT:
      return {
        ...state,
        after_call_chat: [
          ...state.after_call_chat,
          action.payload.after_call_chat,
        ],
      };

    case actionTypes.CLEAR_CHAT:
      return {
        ...state,
        after_call_chat: [],
      };

    case actionTypes.CHAT_NOTIFICATION_MESSAGE:
      return {
        ...state,
        is_chat_notification: action.payload.is_chat_notification,
      };

    default:
      return state;
  }
};

export default ongoingAppointment;
